<div class="or-align-items-center or-d-flex or-flex-col">
  <div class="or-head-xs or-color-secondary-2 or-mb-4-px">{{ label() }}</div>
  <div
    class="or-w-90-pc card-box-shadow border-radius-4 or-p-8-px or-bg-white or-d-flex or-justify-content-center or-text-md"
    [class.or-color-secondary-2]="isEmpty()">
    {{ displayValue() }}
  </div>
</div>
